import { Component, Element, Host, Prop, h } from "@stencil/core";
import { Control } from "@genexus/designer-common";
import { getIconPath } from "@genexus/mercury";

@Component({
  styleUrl: "designer-tool-drag.scss",
  tag: "gx-designer-tool-drag"
})
export class DesignerToolDrag {

  @Element() el: HTMLElement;
  @Prop() control: Control;

  render() {
    return (
      <Host draggable="true">
        <button class="button-tertiary button-icon-only button-icon-drag">
          <ch-image src={getIconPath({
            category: "navigation",
            name: "drag",
            colorType: "primary"
          })} class="icon-md" />
        </button>
      </Host>
    );
  }
}
